import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { GLTFLoader } from 'three/examples/jsm/Addons.js'


import Experience from './Experience/Experience.js'


const experience = new Experience(document.querySelector("canvas.webgl"))

// /**
//  * Base
//  */
// // Debug
// const gui = new GUI()

// // Canvas
// const canvas = document.querySelector('canvas.webgl')

// // Scene
// const scene = new THREE.Scene()

// /**
//  * Textures
//  */
// const textureLoader = new THREE.TextureLoader()
// const gltfLoader = new GLTFLoader()


// gltfLoader.load(
//     './model/gameboy-new.glb',
//     (gltf) => {
//         gltf.scene.traverse((child) => {
//             if (child.isMesh) {
//                 console.log(child.name)

//                 if(child.name == "select" || child.name == "xyab" || child.name == "dpad"){
//                     child.material= new THREE.MeshPhysicalMaterial({ 
//                         color: 0x252525,
//                         roughness: 0.25,
//                         metalness: 0.8
//                     });
//                 }

//                 else if(child.name == "console"){
//                     child.material= new THREE.MeshPhysicalMaterial({ 
//                         color: 0x252525,
//                         roughness: 0.7,
//                         metalness: 0.5
//                     });
//                 }

//                 else if(child.name == "Screen"){
//                     child.material= new THREE.MeshPhysicalMaterial({ 
//                         color: 0x252525,
//                         roughness: 0.0,
//                         metalness: 0.7
//                     });
//                 }

//                 else if(child.name == "power"){
//                     child.material= new THREE.MeshPhysicalMaterial({ 
//                         color: new THREE.Color("#C4F6AE"),
//                         roughness: 0.0,
//                         metalness: 0.5
//                     });
//                 }
//                 // child.material = new THREE.MeshPhysicalMaterial({ color: 0xcccccc });
//             }
//         });
//         gltf.scene.scale.set(0.1, 0.1, 0.1)
//         gltf.scene.rotation.y = Math.PI
//         scene.add(gltf.scene)
//     }
// )


// const pointLight = new THREE.PointLight("white", 20.0, 10, 3)
// pointLight.position.set(0, 0, 5)
// scene.add(pointLight)


// const spotLight = new THREE.SpotLight(new THREE.Color(255, 255, 255), 0.1, 5.0, 260)
// spotLight.position.set(2, 2, 2)
// const spotLight1 = new THREE.SpotLight(new THREE.Color(255, 255, 255), 0.1, 5.0, 260)
// spotLight1.position.set(-2, 2, 3)
// const spotLightHelper = new THREE.SpotLightHelper(spotLight1)
// scene.add(spotLight, spotLight1)
// // scene.add(spotLightHelper)




// const floorGeometery = new THREE.PlaneGeometry(10, 10)
// const floor = new THREE.Mesh(
//     floorGeometery,
//     new THREE.MeshPhysicalMaterial()
// )
// floor.rotation.x = -Math.PI * 0.5
// floor.position.y = -1

// // scene.add(floor)






// /**
//  * Sizes
//  */
// const sizes = {
//     width: window.innerWidth,
//     height: window.innerHeight
// }

// window.addEventListener('resize', () =>
// {
//     // Update sizes
//     sizes.width = window.innerWidth
//     sizes.height = window.innerHeight

//     // Update camera
//     camera.aspect = sizes.width / sizes.height
//     camera.updateProjectionMatrix()

//     // Update renderer
//     renderer.setSize(sizes.width, sizes.height)
//     renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
// })

// /**
//  * Camera
//  */
// // Base camera
// const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
// camera.position.set(0, 0, 1.5)
// scene.add(camera)

// // Controls
// const controls = new OrbitControls(camera, canvas)
// controls.enableDamping = true

// /**
//  * Renderer
//  */
// const renderer = new THREE.WebGLRenderer({
//     canvas: canvas
// })
// renderer.setSize(sizes.width, sizes.height)
// renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

// /**
//  * Animate
//  */
// const clock = new THREE.Clock()

// const tick = () =>
// {
//     const elapsedTime = clock.getElapsedTime()

//     // Update controls
//     controls.update()

//     // Render
//     renderer.render(scene, camera)

//     // Call tick again on the next frame
//     window.requestAnimationFrame(tick)
// }

// tick()